import {
  BaseModal,
  Button,
  Content,
  Flex,
  fromTheme,
  IconButton,
  StrokeIcon,
} from '@acsbe/ui';
import { styled } from 'styled-components';

interface DiscardChangesPopupProps {
  onClose: () => void;
  onDiscard: () => void;
  onPublish: () => void;
  isPublishing?: boolean;
}

export const DiscardChangesPopup = (props: DiscardChangesPopupProps) => {
  const onClose = () => {
    props.onClose();
  };

  const onDiscard = () => {
    props.onDiscard();
    props.onClose();
  };

  const onPublish = () => {
    props.onPublish();
    props.onClose();
  };

  return (
    <>
      <StyledModal open={true} closeButton>
        <CloseButton
          aria-label="Close"
          padding={1.5}
          scale="alternative"
          variant="solid"
          radius="round"
          onClick={() => onClose()}
        >
          <StrokeIcon name="Close" size="lg" />
        </CloseButton>
        <Flex padding={8} paddingBlockStart={6} gap={8}>
          <Flex>
            <Flex gap={4}>
              <Heading>Discard unpublished changes?</Heading>
              <SubHeading>
                You have unpublished changes to your widget. If you leave now
                your changes will be lost.
              </SubHeading>
            </Flex>
          </Flex>
          <Flex gap={4} justify="end" row>
            <DiscardButton
              scale="ghost"
              onClick={() => onDiscard()}
              disabled={props.isPublishing}
            >
              <span>Discard Changes</span>
            </DiscardButton>
            <Button
              scale="primary"
              onClick={() => onPublish()}
              disabled={props.isPublishing}
            >
              <span>Publish Changes</span>
            </Button>
          </Flex>
        </Flex>
      </StyledModal>
    </>
  );
};

const DiscardButton = styled(Button)`
  border: 1px solid #cbd2e1;
`;

const StyledModal = styled(BaseModal)`
  max-width: 520px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  inset-block-start: 5px;
  inset-inline-end: 5px;
  background-color: transparent;
  color: #394c61;
`;

const Heading = styled(Flex)`
  font-size: 28px;
  font-weight: 700;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 22px;
  }
`;

const SubHeading = styled(Content)`
  font-size: 18px;
  line-height: 27px;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 14px;
    line-height: 21px;
  }
`;
